import productApi from '@/service/modules/productApi';
import { Button, Modal, Form, Input, Checkbox, message, Image } from 'antd';
import { useEffect, useState } from 'react';

interface Props {
  onClose: Function;
  isWholesaleOpen: boolean;
  productID: number | undefined;
  goodsName?: string | undefined
} 

export default function NotifyMe({ onClose, isWholesaleOpen, productID, goodsName }: Props) {

  useEffect(() => {
    generate()
  }, [])

  const defaultCaptcha = {
    img: "",
    key: ""
  }
  const [captcha, setCaptcha] = useState(defaultCaptcha)
  const generate = async () => {
    try {
      const res = await productApi.generate()
      const { captcha } = res.data
      setCaptcha(captcha)

    } catch (error: any) {
      message.error(error.message)

    }
  }

  const [btnLoading, setBtnLoading] = useState(false)

  const onFinish = async (values: any) => {
    setBtnLoading(true)
    const params = {
      ...values,
      productID,
      verifyCode: values.captcha,
      key: captcha.key
    }
    try {
      const res = await productApi.addNotify(params)
      setBtnLoading(false)
      onClose()
      message.success("Success")

    } catch (error: any) {
      setBtnLoading(false)
      generate()
      message.error(error.message)
    }
  };

  type FieldType = {
    userName?: string;
    email?: string;
    newsletter?: boolean;
  };

  return (
    <Modal
      title=""
      centered
      open={isWholesaleOpen}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={null}
      width={689}
    >
      <div style={{ width: "575px", margin: "0 auto" }}>
        <h2 style={{ color: "red", fontWeight: "bold", fontSize: "24px", margin: "27px 0 0" }}>Notify me when the item is available!</h2>
        <p style={{ color: "#333333", fontWeight: "bold", fontSize: "14px", margin: "27px 0" }}>
          Please fill out the information below and you will be notified as soon as the item below becomes available.
          Unfortunately, we aren&apos;t able to advise on ETAs for our products, as we often usually restock items at very short notice, due to wholesaler clearances. However, you&apos;ll be the first to know if you register for this email alert! {goodsName && goodsName}
        </p>
        <Form
          name="wholesale"
          layout="horizontal"
          labelAlign="left"
          labelCol={{ flex: '200px' }}
          labelWrap
          onFinish={onFinish}
        >
          <Form.Item<FieldType>
            label="Name:"
            name="userName"
            rules={[{ required: true, message: 'please input your name' }]}
          >
            <Input placeholder='Name' />
          </Form.Item>

          <Form.Item<FieldType>
            label="Email:"
            name="email"
            rules={[{ required: true, message: "please input your email" }, { type: "email" }]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item<FieldType>
            label="To Generate New Code, Click Picture:"
          >
            <Image
              src={captcha.img}
              preview={false}
              alt='code-image'
              width={120}
              height={35}
              style={{ cursor: "pointer" }}
              onClick={generate}
            />
          </Form.Item>

          <Form.Item<FieldType>
            label="Input Confirmation Code:"
            name="captcha"
            rules={[{ required: true, message: "please input your code" }]}
          >
            <Input placeholder="Code" />
          </Form.Item>

          <Form.Item
            name="newsletter"
            valuePropName="checked"
          >
            <Checkbox>
              I would like to receive your Newsletter to be the first to know about hot offers!
            </Checkbox>
          </Form.Item>


          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" loading={btnLoading} htmlType="submit" style={{ width: "136px", height: "32px", padding: "0" }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}